module.exports = __webpack_public_path__ + "static/media/434138069_796023965721357_84092651723512389_n.35875e99.jpg";